// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_header__TBfIQ {
  width: 100vw;
  position: fixed;
  top: 0;
  z-index: 90;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  background-color: var(--background-color);
}

.styles_logo__VfwHJ img {
  height: 2.5rem;
  width: auto;
}

.styles_nav__7XsKt {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
}
.styles_nav__7XsKt > div {
  opacity: 0.7;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
}
.styles_nav__7XsKt > div:hover {
  opacity: 1;
}
.styles_nav__7XsKt .styles_selected__uMeI8 {
  opacity: 1;
  font-weight: 700;
}

.styles_burger__xpCSL {
  width: 1.5rem;
  height: 1.5rem;
  stroke-width: 2px;
  stroke: var(--text-color);
}
.styles_burger__xpCSL .styles_top__GVIX2 {
  transform: translateY(-22%);
  transition: all 0.5s ease-out;
}
.styles_burger__xpCSL .styles_top__GVIX2.styles_opened__dtS9c {
  transform: rotate(45deg);
  transform-origin: center;
}
.styles_burger__xpCSL .styles_middle__i7a48 {
  transition: all 0.5s ease-out;
}
.styles_burger__xpCSL .styles_middle__i7a48.styles_opened__dtS9c {
  transform: scaleX(0.1);
  transform-origin: center;
}
.styles_burger__xpCSL .styles_bottom__Zr3ij {
  transform: translateY(22%);
  transition: all 0.5s ease-out;
}
.styles_burger__xpCSL .styles_bottom__Zr3ij.styles_opened__dtS9c {
  transform: rotate(-45deg);
  transform-origin: center;
}

.styles_menu__\\+S6yd {
  position: absolute;
  z-index: 100;
  width: 100vw;
  height: -moz-fit-content;
  height: fit-content;
  top: 76px;
  right: 0;
  padding: 1rem 2rem 1rem 2rem;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  align-items: flex-end;
  gap: 1rem;
  background-color: var(--text-color);
  color: var(--background-color);
}`, "",{"version":3,"sources":["webpack://./src/component/header/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;EACA,yCAAA;AACF;;AAGE;EACE,cAAA;EACA,WAAA;AAAJ;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AADF;AAGE;EACE,YAAA;EACA,gCAAA;EACA,eAAA;AADJ;AAGI;EACE,UAAA;AADN;AAKE;EACE,UAAA;EACA,gBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;AAJF;AAME;EACI,2BAAA;EACA,6BAAA;AAJN;AAMM;EACI,wBAAA;EACA,wBAAA;AAJV;AAQE;EACI,6BAAA;AANN;AAQM;EACI,sBAAA;EACA,wBAAA;AANV;AAUE;EACI,0BAAA;EACA,6BAAA;AARN;AAUM;EACI,yBAAA;EACA,wBAAA;AARV;;AAaA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,wBAAA;EAAA,mBAAA;EACA,SAAA;EACA,QAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;EACA,mCAAA;EACA,8BAAA;AAVF","sourcesContent":[".header {\n  width: 100vw;\n  position: fixed;\n  top: 0;\n  z-index: 90;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.5rem;\n  background-color: var(--background-color);\n}\n\n.logo {\n  img {\n    height: 2.5rem;\n    width: auto;\n  }\n}\n\n.nav {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 1rem;\n\n  > div {\n    opacity: 0.7;\n    transition: all 0.3s ease-in-out;\n    cursor: pointer;\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n\n  .selected {\n    opacity: 1;\n    font-weight: 700;\n  }\n}\n\n.burger {\n  width: 1.5rem;\n  height: 1.5rem;\n  stroke-width: 2px;\n  stroke: var(--text-color);\n\n  .top {\n      transform: translateY(-22%);\n      transition: all 0.5s ease-out;\n\n      &.opened {\n          transform: rotate(45deg);\n          transform-origin: center;\n      }\n  }\n\n  .middle {\n      transition: all 0.5s ease-out;\n\n      &.opened {\n          transform: scaleX(0.1);\n          transform-origin: center;\n      }\n  }\n\n  .bottom {\n      transform: translateY(22%);\n      transition: all 0.5s ease-out;\n\n      &.opened {\n          transform: rotate(-45deg);\n          transform-origin: center;\n      }\n  }\n}\n\n.menu {\n  position: absolute;\n  z-index: 100;\n  width: 100vw;\n  height: fit-content;\n  top: 76px;\n  right: 0;\n  padding: 1rem 2rem 1rem 2rem;\n  display: flex;\n  box-sizing: border-box;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 1rem;\n  background-color: var(--text-color);\n  color: var(--background-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `styles_header__TBfIQ`,
	"logo": `styles_logo__VfwHJ`,
	"nav": `styles_nav__7XsKt`,
	"selected": `styles_selected__uMeI8`,
	"burger": `styles_burger__xpCSL`,
	"top": `styles_top__GVIX2`,
	"opened": `styles_opened__dtS9c`,
	"middle": `styles_middle__i7a48`,
	"bottom": `styles_bottom__Zr3ij`,
	"menu": `styles_menu__+S6yd`
};
export default ___CSS_LOADER_EXPORT___;
